import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import { Tooltip } from "reactstrap";
import { useTranslation } from "react-i18next";
//import { Badge, Button } from 'reactstrap';
// import Badge from '@mui/material/Badge';
import { Badge } from "@mui/material";
// import PendingList from "../../views/PendingList/PendingList";

function Home(props) {
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const { t } = useTranslation();

  const count = useSelector(({ plCount }) => plCount);

  const toggle = () => setTooltipOpen(!tooltipOpen);
  return (
    <div className="notification">
      <Link to="/" id="HomePage" style={{ fontSize: '18px', color: '#fff' }}>
        <i class="fas fa-home"></i>
      </Link>
      <Tooltip
        placement="bottom"
        isOpen={tooltipOpen}
        target="HomePage"
        toggle={toggle}
      >
        {t("Home Page")}
      </Tooltip>
    </div>
  );
}

export default withRouter(Home);
